export default __webpack_public_path__ + "static/dropdownMenu_cloud_left-95e18dc43b06835e074dcc6c29879369.png";